import { SplitIOType } from "hooks/use-splitio";
import { createContext, useContext } from "react";

const SplitIOContext = createContext<SplitIOType | undefined>(undefined);
export const useSplitIOContext = () => useContext(SplitIOContext);
export default SplitIOContext;
